import { EntityTypesSupportingFieldCustomization } from "@mapmycustomers/shared/types/entity";
import { LayoutSchemaField } from "@mapmycustomers/shared/types/layout/FormLayout";
import { EntityTypeMap } from "@mapmycustomers/shared/types/layout/ILayoutModel";
import { OnlyRequiredFields } from "@mapmycustomers/shared/util/ts";

import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";

const getMissingRequiredFields = <T extends EntityTypesSupportingFieldCustomization>(
  schema: LayoutSchemaField[],
  entity: OnlyRequiredFields<EntityTypeMap[T], "entity">
): LayoutSchemaField[] => {
  const fieldModel = getFieldModelByEntityType(entity.entity);
  return schema.filter((schemaField) => {
    if (!schemaField.required) {
      return false;
    }
    const field = fieldModel.getByPlatformName(schemaField.field);
    return field ? !field.hasNonEmptyValueFor(entity) : false;
  });
};

export default getMissingRequiredFields;
